import { getMelbourneTimezoneAbbr } from './getMelbourneTimezoneAbbr'

export class setCurrentTemp {

  constructor(div = 'data-current-temp') {
    this.div = div; //falls back to updating a Div with the attribute 'data-current-temp'
    this.updateInterval = 60 * 60 * 1000; // 15 minutes in milliseconds

    this.init();
  }

  async updateTemperature() {
    try {
      const response = await fetch('/!/Weather/current');
      const data = await response.json();

      const temperature = data.temp;
      const elements = document.querySelectorAll(`[${this.div}]`);

      const tzAbbr = getMelbourneTimezoneAbbr();

      elements.forEach(element => {
        element.innerHTML = `${tzAbbr} ${temperature.toFixed(1)}°`; // Display temperature with one decimal place
        // element.innerHTML = `${tzAbbr} ${Math.round(temperature)}°`; // Display temperature to nearest integer
      });
    } catch (error) {
      console.error('Failed to fetch temperature data:', error);
    }
  }

  init() {
    // Call updateTemperature immediately
    this.updateTemperature();

    // Set up the periodic update
    setInterval(() => {
      this.updateTemperature();
    }, this.updateInterval);
  }
}

// Example usage with data attribute name 'data-current-temp'
// const temperatureUpdater = new setCurrentTemp();


